// src/pages/StartFooter.tsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSelector from '../../components/LanguageSelector';

const languages = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "ru", label: "Русский" },
  { code: "tr", label: "Türkçe" },
  { code: "ar", label: "العربية" },
  { code: "hi", label: "हिन्दी" },
];

const StartFooter: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showLanguage, setShowLanguage] = useState(false);
  const currentLanguageCode =
    i18n.resolvedLanguage || i18n.language || "en";

  const currentLanguage =
    languages.find((lang) =>
      currentLanguageCode.startsWith(lang.code)
    )?.label || "English";


return (
    <>
      <style>
        {`
          .start-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 18px clamp(24px, 5vw, 80px) 20px;
  background: rgba(3, 7, 18, 0.96);
  border-top: 1px solid #1f2937;
}

          .start-footer-inner {
            width: 100%;
            max-width: 1320px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: auto minmax(0, 1fr) auto;
            align-items: center;
            gap: 24px;
            box-sizing: border-box;
            color: #9ca3af;
            font-size: 12px;
          }

          .start-footer-brand {
            white-space: nowrap;
            opacity: 0.9;
          }

          .start-footer-links {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 24px;
            flex-wrap: wrap;
            min-width: 0;
          }

          .start-footer-actions {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
            flex-wrap: wrap;
          }

      @media (max-width: 980px) {
  .start-footer-inner {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 16px;
    text-align: center;
  }

  .start-footer-links,
  .start-footer-actions {
    justify-content: center;
  }
}

          @media (max-width: 620px) {
            .start-footer {
              padding-inline: 18px;
            }

            .start-footer-brand {
              white-space: normal;
            }

            .start-footer-links {
              gap: 16px;
            }

            .start-footer-actions {
              width: 100%;
              white-space: normal;
            }
          }
        `}
      </style>

      <footer className="start-footer">
        <div className="start-footer-inner">
          <div className="start-footer-brand">
            <span style={{ fontWeight: 600 }}>Elnydo</span>

            <span style={{ marginLeft: 6 }}>
              · {t("home.footer.tagline")}
            </span>
          </div>

          <nav
            className="start-footer-links"
            aria-label="Footer navigation"
          >
            <button
              type="button"
              onClick={() => navigate("/legal/termsofuse")}
              style={footerLinkStyle}
            >
              {t("home.footer.links.termsOfUse")}
            </button>

            <button
              type="button"
              onClick={() => navigate("/legal/privacypolicy")}
              style={footerLinkStyle}
            >
              {t("home.footer.links.privacyPolicy")}
            </button>

            <button
              type="button"
              onClick={() => navigate("/helpsupportstart")}
              style={footerLinkStyle}
            >
              {t("home.footer.links.helpSupport")}
            </button>
          </nav>

          <div className="start-footer-actions">
            <a
              href="#"
              onClick={(event) => event.preventDefault()}
              style={storeButtonStyle}
              aria-label="Download on the App Store"
            >
               <span>App Store</span>
            </a>

            <a
              href="#"
              onClick={(event) => event.preventDefault()}
              style={storeButtonStyle}
              aria-label="Get it on Google Play"
            >
              ▶ <span>Google Play</span>
            </a>

            <div style={{ position: "relative" }}>
              <button
                type="button"
                onClick={() => setShowLanguage((current) => !current)}
                style={languageButtonStyle}
              >
                🌐 <span>{currentLanguage}</span>
              </button>

              {showLanguage && (
                <LanguageSelector
                  onClose={() => setShowLanguage(false)}
                  offsetY={-10}
                />
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

const footerLinkStyle: React.CSSProperties = {
  padding: 0,
  border: "none",
  background: "none",
  color: "#9ca3af",
  cursor: "pointer",
  fontSize: 12,
};

const storeButtonStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "6px 10px",
  border: "1px solid #4b5563",
  borderRadius: 999,
  color: "#e5e7eb",
  textDecoration: "none",
  fontSize: 11,
  whiteSpace: "nowrap",
};

const languageButtonStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "6px 10px",
  border: "1px solid #4b5563",
  borderRadius: 999,
  background: "transparent",
  color: "#e5e7eb",
  cursor: "pointer",
  fontSize: 11,
  whiteSpace: "nowrap",
};

export default StartFooter;